var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Grid, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { NewsletterReportService } from "../../../services/newsletter/newsletterReport.service";
import LabeledValue from "../../LabeledValue";
var ProfileMarketing = function (_a) {
    var _b;
    var profile = _a.profile;
    var t = useTranslation().t;
    var _c = useState(null), newsletterReportInfo = _c[0], setNewsletterReportInfo = _c[1];
    var profileId = profile.id;
    var hasEmails = !!((_b = profile.emails) === null || _b === void 0 ? void 0 : _b.length);
    useEffect(function () {
        var active = true;
        setNewsletterReportInfo(null);
        if (profileId && hasEmails) {
            NewsletterReportService.getNewsletterReportInfo(profileId).then(function (report) {
                if (active)
                    setNewsletterReportInfo(report);
            });
        }
        return function () { active = false; };
    }, [profileId, hasEmails]);
    var renderOptinInfo = function (status) { return status == null ? '-' : t(status ? 'Yes' : 'No'); };
    return (_jsxs(Grid, __assign({ container: true, spacing: 2, mt: 0 }, { children: [_jsx(Grid, __assign({ item: true, xs: 4 }, { children: _jsx(LabeledValue, __assign({ label: t('Newsletter optin') }, { children: _jsx(Typography, { children: renderOptinInfo(profile.receiveNewsletters) }) })) })), _jsx(Grid, __assign({ item: true, xs: 4 }, { children: _jsx(LabeledValue, __assign({ label: t('Newsletter opening times') }, { children: _jsx(Typography, { children: newsletterReportInfo && newsletterReportInfo.totalCount > 0 ? ("".concat(newsletterReportInfo.openingsCount, " / ").concat(newsletterReportInfo.totalCount)) : ('-') }) })) })), _jsx(Grid, __assign({ item: true, xs: 4 }, { children: _jsx(LabeledValue, __assign({ label: t('Last newsletter link click') }, { children: (newsletterReportInfo === null || newsletterReportInfo === void 0 ? void 0 : newsletterReportInfo.lastClickUrl) ? (_jsx(Typography, __assign({ component: "a", href: newsletterReportInfo.lastClickUrl, target: "_blank", rel: "noopener noreferrer", sx: {
                            display: 'inline-block',
                            maxWidth: '100%',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                            direction: 'rtl',
                            textAlign: 'left',
                        }, title: newsletterReportInfo.lastClickUrl }, { children: newsletterReportInfo.lastClickUrl }))) : (_jsx(Typography, { children: "-" })) })) }))] })));
};
export default ProfileMarketing;
